// extracted by mini-css-extract-plugin
module.exports = {"footer__copyright":"FooterCopyright_footer__copyright__2m0hT","bottom":"FooterCopyright_bottom__3iv1B"};